import client from "../client";
import { DataSelectType } from "../../models/DataSelectType";
import { PurchaseOrderInterface } from "../../models/ProcurementModule/PurchateOrder/PurchaseOrder";
const listName = "PurchaseOrders";
class PurchaseOrderService {
  async GetAll(page: number, pageSize: number, filters?: DataSelectType[]) {
    try {
      let url = `/api/${listName}/get`;

      let form: any = {
        page,
        pageSize,
      };

      if (filters && filters.length > 0) {
        filters.map(
          (item) =>
            (form[item.field === "YearId" ? "Year" : item.field] = item.value)
        );
      }

      const { data } = await client.post<PurchaseOrderInterface[]>(url, form);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      const { data } = await client.get<PurchaseOrderInterface>(
        `/api/${listName}/getbyid/${id}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Create(
    item: PurchaseOrderInterface,
    fileNames: {
      fileUrl: string;
      fileName: string;
    }[]
  ) {
    try {
      const url = `/api/${listName}/create`;

      const { invoices, code, purchaseOrderLines, date, ...formData } = item;

      const form = new FormData();

      for (const key in formData) {
        if (key !== "uploadInvoices") {
          // Skip uploadInvoices for now
          form.append(key, (formData as any)[key]);
        }
      }

      if (Array.isArray(purchaseOrderLines)) {
        purchaseOrderLines.forEach((line, index) => {
          form.append(
            `purchaseOrderLines[${index}].title`,
            line.title.toString()
          );
          form.append(
            `purchaseOrderLines[${index}].price`,
            line.price.toString()
          );
          form.append(
            `purchaseOrderLines[${index}].quantity`,
            line.quantity.toString()
          );
        });
      }

      if (formData.uploadInvoices && Array.isArray(formData.uploadInvoices)) {
        for (let i = 0; i < formData.uploadInvoices.length; i++) {
          const base64File = formData.uploadInvoices[i];
          let filename = "";

          let realFileName = fileNames.find(
            (item) => item.fileUrl === base64File
          )?.fileName;

          if (realFileName) {
            filename = realFileName;
          } else {
            const match = base64File.match(/data:([^;]+);base64/);
            if (!match) {
              throw new Error(`Invalid Base64 format for file at index ${i}`);
            }

            const mimeType = match[1];
            const extension = mimeType.split("/")[1];
            filename = `file${i}.${extension}`;
          }

          const blob = await fetch(base64File).then((res) => res.blob());
          form.append("UploadInvoices", blob, filename);
        }
      }

      form.append(
        "date",
        date instanceof Date
          ? date.toISOString()
          : date
          ? new Date(`${date}T12:00:00Z`).toISOString()
          : ""
      );

      const { data } = await client.post<PurchaseOrderInterface>(url, form);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(
    id: string | undefined,
    item: PurchaseOrderInterface,
    fileNames: {
      fileUrl: string;
      fileName: string;
    }[]
  ) {
    try {
      const { id, purchaseOrderLines, ...formData } = item;
      const url = `/api/${listName}/update/${id}`;
      const form = new FormData();

      for (const key in formData) {
        if (key !== "uploadInvoices" && (key as string) !== "invoices") {
          form.append(key, (item as any)[key]);
        }
      }

      if (Array.isArray(purchaseOrderLines)) {
        purchaseOrderLines.forEach((line, index) => {
          form.append(
            `purchaseOrderLines[${index}].title`,
            line.title.toString()
          );
          form.append(
            `purchaseOrderLines[${index}].price`,
            line.price.toString()
          );
          form.append(
            `purchaseOrderLines[${index}].quantity`,
            line.quantity.toString()
          );
        });
      }

      formData.invoices &&
        formData.invoices.forEach((file: any, index: number) => {
          delete file.extension;
          form.append(`invoices[${index}][fileUrl]`, file.fileUrl);
          form.append(`invoices[${index}][fileSize]`, file.fileSize);
          form.append(`invoices[${index}][fileName]`, file.fileName);
        });

      if (formData.uploadInvoices && Array.isArray(formData.uploadInvoices)) {
        for (let i = 0; i < item.uploadInvoices.length; i++) {
          const base64File = item.uploadInvoices[i];

          let filename = "";
          let realFileName = fileNames.find(
            (item) => item.fileUrl === base64File
          );
          if (realFileName && realFileName.fileName) {
            filename = realFileName.fileName;
          } else {
            const match = base64File.match(/data:([^;]+);base64/);
            if (!match) {
              throw new Error(`Invalid Base64 format for file at index ${i}`);
            }
            const mimeType = match[1];
            const extension = mimeType.split("/")[1];
            filename = `file${i}.${extension}`;
          }

          const blob = await fetch(base64File).then((res) => res.blob());
          form.append("UploadInvoices", blob, filename);
        }
      }

      const { data } = await client.post<PurchaseOrderInterface>(url, form);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Remove(id: string) {
    try {
      const { data } = await client.post<PurchaseOrderInterface>(
        `/api/${listName}/remove/${id}`,
        { url: "" }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new PurchaseOrderService();
